import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import { GetCompanyEmployeesWorkoutWatchtime, GetNumberOfEmployees, GetTeamFavoriteWorkouts, } from '../../../redux/v2/company/actions';
import ProgressBar from "../../../common/ProgressBar";
import useCompany from "../../../hooks/useCompany";
import { AcceptChallenge } from "../../../redux/v2/challenge/actions";

function CompanyChallengeBanner(props) {
    const navigate = useNavigate();
    const { challenges } = props.Challenge;
    const { account } = props.User;
    const { companyLogo, daysToGo, daysLeft, companyName, launchDate } = useCompany({ user: account?.user });
    const isClicked = localStorage.getItem("indi-cc-banner-clicked") || false;
    return (
        <div onClick={() => {
            let companyChallenge = challenges.filter(cha => cha.company == props.User?.user?.company)
            if (companyChallenge[0].status == 0 && !isClicked) {
                props.AcceptChallenge(companyChallenge[0].id);
            }
            navigate(`/challenges?challenge=${companyChallenge[0].id}`)
            localStorage.setItem("indi-cc-banner-clicked", true);
        }}>
            {
                (daysToGo > 0)
                    ? <div className={`cc-milestone ${isClicked ? "" : "dark"}`}>
                        <div className="cc-milestone-circle" style={{ backgroundColor: "#fff" }}>
                            <div id="milestone-badge" className="">
                                <img src={companyLogo} className="badge-img" style={{ width: "90%" }} />
                            </div>
                        </div>
                        <div className="cc-milestone-desc">
                            <h5>{companyName?.toUpperCase()} CHALLENGE</h5>
                            <p>{daysToGo} days until the challenge begins!</p>
                        </div>
                    </div>
                    : <div className="cc-milestone ">
                        <div className="cc-milestone-circle" style={{ backgroundColor: "#fff" }}>
                            <div id="milestone-badge" className="">
                                <img src={companyLogo} className="badge-img" style={{ width: "90%" }} />
                            </div>
                        </div>
                        <div className="cc-milestone-desc">
                            <h5>{companyName?.toUpperCase()} CHALLENGE</h5>
                            <ProgressBar min={0} max={10} value={0} height="7px" showLabel={false} />
                        </div>
                    </div>
            }

        </div>

    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Challenge: state.Challenge,
});

export default connect(mapStateToProps, {
    GetCompanyEmployeesWorkoutWatchtime,
    GetNumberOfEmployees,
    GetTeamFavoriteWorkouts,
    AcceptChallenge,
})(CompanyChallengeBanner);